/**
 * Caching for the global admin key, shared by the admin screen and the course-map
 * builder (which is a separate page and a separate bundle, so this can't live in a
 * screen module).
 *
 * A guardrail, not a permission boundary: the key is only ever checked server-side by
 * requireAdminKey, and everything here does is save re-typing it.
 */
const KEY_STORAGE = "golf:admin-key";

/**
 * Shorter than a per-tournament auth token's TTL (storage.ts) — this key unlocks
 * cross-tournament management for every tournament on the deployment, so a shared or
 * kiosk device should stop trusting a cached copy of it sooner.
 */
const KEY_TTL_MS = 24 * 60 * 60 * 1000;

export function loadCachedAdminKey(): string {
  try {
    const raw = localStorage.getItem(KEY_STORAGE);
    if (!raw) return "";
    const { key, savedAt } = JSON.parse(raw) as { key: string; savedAt: number };
    if (Date.now() - savedAt > KEY_TTL_MS) {
      localStorage.removeItem(KEY_STORAGE);
      return "";
    }
    return key;
  } catch {
    return "";
  }
}

export function saveCachedAdminKey(key: string) {
  try {
    localStorage.setItem(KEY_STORAGE, JSON.stringify({ key, savedAt: Date.now() }));
  } catch {
    // storage unavailable — the key just won't be remembered across reloads
  }
}
